<template>
  <div class="mb-3">
    <custom-callout
      class="custom-callout"
      :class="[{ 'bg-white': fromAcquisition }]"
      :opened="isPanelOpen"
      :controlled="true"
      :border-color="item.statusColor"
      @click:open="onToggle()"
    >
      <div class="row">
        <div
          :class="{
            'col-11':
              (isProcessed || isAvailable || isInactivated || isReturned) &&
              checkable,
            'col-12': !(
              (isProcessed || isAvailable || isInactivated || isReturned) &&
              checkable
            ),
          }"
        >
          <div class="row py-3">
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estatus:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                <custom-balloon
                  :background-color="item.statusColor"
                  class="mt-2"
                  :text="item.statusName"
                  dot
                />
              </div>
            </div>
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre de Equipo:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.name | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Código de Equipo:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.code | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estado del Equipo:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.equipmentStatus | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12 col-spacing mb-3 mb-lg-0">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                CAAT Asignado:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ item.caat | empty }}
              </div>
            </div>
            <div class="col">
              <drop-down
                always-show-dropdown
                :items="actionItems"
                class="float-md-right mr-5"
              />
            </div>
          </div>
          <div class="col-12 border-bottom-2"></div>
          <div class="row py-3">
            <div
              class="col-md-2 col-12 col-spacing mb-3 mb-lg-0"
              v-for="(property, key) in item.properties"
              :key="key"
            >
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                {{ property.id }}:
              </div>
              <div class="color-black font-16 font-weight-normal text-break">
                {{ property.name }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            checkable &&
              (isProcessed || isAvailable || isInactivated || isReturned)
          "
          class="col border-left"
        >
          <div class="d-flex justify-content-center align-items-center h-100">
            <checkbox
              checked-bg-color="bg-success"
              icon="fal fa-check"
              class="d-flex justify-content-center"
              v-model="item.checked"
              @input="check(item)"
            />
          </div>
        </div>
      </div>
      <template #edition>
        <div v-if="showAssignEquipment" class="py-4 px-2 bg-light-gray">
          <div class="bg-white px-4 py-4">
            <div class="mb-3 font-weight-bold">
              <i class="fas fa-info-circle text-orange mr-2"></i>
              Seleccione Accesorios para el Equipo
            </div>
            <equipment-accessories
              ref="equipment-accessories"
              class="px-3"
              :equipment="item"
              :recommendation="recommendation"
              @close="onCloseCallout()"
            />
          </div>
        </div>
        <div v-if="showTransfer" class="py-4 px-2 bg-light-gray">
          <div class="px-4 py-4">
            <icon-view
              class="mb-3"
              :has-border="false"
              icon="fas fa-arrow-right-arrow-left text-orange"
              icon-size="17px"
              title="Solicitud de Transferencia de Equipo"
              variant="custom-icon-view"
              icon-background="white"
            />
            <transfer-request
              :recommendation="recommendation"
              :equipment="item"
              @close="onCloseCallout()"
            />
          </div>
        </div>
        <div v-if="showTransferCancellation" class="py-4 bg-light-gray">
          <transfer-cancellation
            :equipment-id="item.id"
            :recommendation-id="recommendation?.id"
            @close="onCancelAction()"
            @refresh="onCloseCallout"
          />
        </div>
        <div v-if="showTransferConfirmation" class="py-4 bg-light-gray">
          <transfer-confirmation
            :transfer="item.transfer"
            :recommendation-id="recommendation?.id"
            @close="onCancelAction()"
            @refresh="onCloseCallout"
          />
        </div>
        <div
          v-if="!inventoryFlow && showEquipment"
          class="py-4 px-5 bg-light-gray"
        >
          <div class="mb-3 font-weight-bold">
            <i class="fas fa-info-circle text-orange mr-2"></i>
            Descripción del Equipo
          </div>

          <div class="d-flex flex-column gap-y-2">
            <div>
              <div class="color-secondary-6 font-14">
                Descripción del Equipo:
              </div>
              <div>
                {{ item.description | empty }}
              </div>
            </div>
            <div>
              <div class="color-secondary-6 font-14">
                Datos de Ubicación/Dirección:
              </div>
              <div>
                {{ item.address | empty }}
              </div>
            </div>
          </div>
          <div v-if="item.accessories.length > 0" class="pt-4 row ml-0">
            <div class="col-12 mb-4 pl-0">
              <div class="color-secondary-6 font-14">
                Accesorio(s) Seleccionado(s):
              </div>
            </div>
            <div
              class="col-12 col-lg-3 bg-white rounded d-flex justify-content-between p-3 mr-2"
              v-for="(accessory, index) in item.accessories"
              :key="index"
            >
              <div>
                <p class="font-16 font-weight-bold mb-0">
                  {{ accessory.id }}
                </p>
                <p class="font-14 mb-0">
                  <span class="text-muted">
                    {{ accessory.name }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showBinnacle" class="py-4 px-5 bg-light-gray">
          <validation-observer ref="binnacleForm">
            <div class="mb-3">
              <icon-view
                :has-border="false"
                icon="mt-1 fas fa-comment text-orange"
                icon-size="18px"
                title="Añadir Bitácora"
                variant="custom-icon-view"
                icon-background="white"
              />
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="color-secondary-6 font-14">
                  Asunto:
                </div>
                <validation-provider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-input
                    placeholder="Asunto"
                    :error="errors[0]"
                    custom-error-msg="El asunto es requerido."
                    v-model="binnacleModel.subject"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-md-4 ">
                <div class="color-secondary-6 font-14">
                  Archivo:
                </div>
                <custom-file-input
                  ref="file"
                  accept=".pdf"
                  display-style="normal"
                  v-model="binnacleModel.file"
                  :on-download="() => {}"
                />
              </div>
            </div>
            <div class="mt-4 mb-3">
              <label class="form-label color-secondary-6 font-14">
                Comentario de la Bitácora:
              </label>
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <custom-text-area
                  placeholder="Escriba Comentario"
                  v-model="binnacleModel.comment"
                  :maxlength="3000"
                  :error="errors[0]"
                  custom-error-msg="El comentario es requerido."
                  :show-char-count="true"
                  :count-classes="['d-block text-right']"
                />
              </validation-provider>

              <div class="d-flex flex-row-reverse bd-highlight">
                <div>
                  <action-button
                    variant="mt-4 success px-3"
                    text="Guardar"
                    i="fas fa-save"
                    @click="saveBinnacle"
                  ></action-button>
                </div>
                <div>
                  <action-button
                    @click="onToggle"
                    variant="mt-4 outline-danger mr-3 px-3"
                    text="Cancelar"
                    type="button"
                    i="fas fa-times-circle"
                  ></action-button>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
        <div v-if="showAdditionalInfo" class="py-4 px-2 bg-light-gray">
          <div class="bg-white px-4 py-4 rounded">
            <additional-info :item="item" />
          </div>
        </div>
        <div v-if="showTransferRequestInfo" class="py-4 px-2 bg-gray">
          <transfer-request-info :transfer-id="item.transfer?.id" />
        </div>
        <div v-if="showCaatAssignment" class="py-4 px-4 bg-light-gray">
          <caat-assignment :item="item" @close="onCancelAction()" />
        </div>
        <div v-if="showLoanForm" class="py-3 p-4 bg-light-gray">
          <loan-equipment
            :item="item"
            @close="onCancelAction()"
            @save="handlerLoanEquipment"
          >
            <template #accessories>
              <div class="bg-white px-4 py-4 mt-3 rounded">
                <div class="mb-3 font-weight-bold">
                  <i class="fas fa-info-circle text-orange mr-2"></i>
                  {{ loanTitle }}
                </div>
                <equipment-accessories
                  ref="equipment-accessories"
                  class="px-3"
                  hide-buttons
                  :assigned="isEquipmentAssigned || isEquipmentLoan"
                  :equipment="item"
                  :recommendation="recommendation"
                  @onSelectAccessory="(e) => (unSelectedItems = e)"
                  @close="onCloseCallout()"
                />
              </div>
            </template>
          </loan-equipment>
        </div>
        <div v-if="showSeizeForm" class="py-3 p-4 bg-light-gray">
          <confiscate-equipment
            :item="item"
            @close="onCancelAction()"
            @save="handlerConfiscate"
          />
        </div>
        <div v-if="showNotifyReturnForm" class="py-3 p-4 bg-light-gray">
          <notify-return
            :item="item"
            @close="onCancelAction()"
            @save="handlerNotifyReturnDate"
          />
        </div>
        <div v-if="showLoanExtensionForm" class="py-3 p-4 bg-light-gray">
          <loan-extension
            :item="item"
            @close="onCancelAction()"
            @save="handlerNotifyExtensionReturnDate"
          />
        </div>
      </template>
    </custom-callout>
    <div
      v-if="isAlertvisible"
      class="alert font-weight-bold border-top-0"
      :class="[setAlertType]"
      role="alert"
    >
      <i class="fas fa-bell-exclamation mr-1"></i>
      {{ alertMessage }}
    </div>
    <div
      v-if="isCaatMissing && isCaatAlertActivated"
      class="alert alert-danger text-danger font-weight-bold border-top-0"
      role="alert"
    >
      <i class="fas fa-exclamation-circle mr-1"></i>
      El equipo debe tener asignado un CAAT para poder marcarlo disponible.
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import Checkbox from 'CheckBox';
import EquipmentAccessories from '../components/EquipmentAccessories.vue';
import AdditionalInfo from './AdditionalInfo.vue';
import CaatAssignment from './CaatAssignment.vue';
import TransferRequestInfo from './TransferRequestInfo.vue';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import mixAlert from '@/mixins/alert.mixin';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import peiAtServiceEquipmentStatus from '@/utils/constants/peiAtServiceEquipmentStatus';
import TransferRequest from './TransferRequest';
import IconView from 'icon-view';
import TransferCancellation from '@/views/at/referralAndEquipment/requisitionAnalysis/components/TransferCancellation.vue';
import TransferConfirmation from '@/views/at/referralAndEquipment/requisitionAnalysis/components/TransferConfirmation.vue';
import LoanEquipment from './LoanEquipment.vue';
import LoanExtension from './LoanExtension.vue';
import ConfiscateEquipment from './ConfiscateEquipment.vue';
import NotifyReturn from './NotifyReturn.vue';
import transferStatuses from '@/utils/constants/peiAtServiceTransferStatus';
import ActionButton from '@/components/common/ActionButton.vue';
import CustomFileInput from 'CustomFileInput';
import CustomInput from 'CustomInput';
import CustomTextArea from '@quisit/custom-text-area';
import { serialize as objectToFormData } from 'object-to-formdata';
import moment from 'moment';
import { date } from '@/utils/filters.js';
import TypeFacility from '@/utils/constants/typeFacility';
import InventoryManagementDetailTabs from '@/utils/constants/inventoryManagementDetailTabs';

const TEMPLATE_TAB_INDEX = {
  ASSIGNEQUIPMENT: 1,
  TRANSFER: 2,
  EQUIPMENTINFO: 3,
  TRANSFERCANCELLATION: 4,
  TRANSFERINFO: 5,
  TRANSFERCONFIRMATION: 6,
  ASSIGNCAAT: 7,
  LOANEQUIPMENT: 8,
  BINNACLE: 9,
  SEIZE: 10,
  BINNACLEHISTORY: 11,
  NOTIFYRETURN: 12,
  LOANEXTENSION: 13,
};
export default {
  name: 'InventoryManagementResultRow',
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    Checkbox,
    EquipmentAccessories,
    AdditionalInfo,
    TransferRequest,
    IconView,
    TransferCancellation,
    TransferConfirmation,
    TransferRequestInfo,
    CaatAssignment,
    LoanEquipment,
    ActionButton,
    CustomFileInput,
    CustomInput,
    CustomTextArea,
    ConfiscateEquipment,
    NotifyReturn,
    LoanExtension,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
    recommendation: {
      type: Object,
      required: false,
      default: null,
    },
    referral: {
      type: Object,
      required: false,
      default: null,
    },
    inventoryFlow: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    fromAcquisition: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    outOfMyInventory: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    canViewStatusSummary: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    checkable: {
      type: Boolean,
      default: () => false,
    },
    isCaatAlertActivated: {
      type: Boolean,
      default: () => false,
    },
    editable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedTemplateTabIndex: null,
      accesories: [],
      unSelectedItems: [],
      isOpen: false,
      binnacleModel: {
        subject: null,
        file: null,
        comment: null,
        equipmentStatusId: null,
      },
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    actionItems() {
      return [
        {
          name: 'Descripción del Equipo',
          icon: 'fas fa-info-circle text-green',
          click: async () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Ver Detalle de Equipo',
          icon: 'fas fa-bars text-green',
          visible: this.canViewStatusSummary,
          click: () => {
            this.$router.push({
              name: 'inventoryMaintenanceEquipmentDetails',
              params: {
                id: this.$route.params.id,
                equipmentId: this.item.id,
              },
            });
          },
        },
        {
          name: 'Editar Equipo',
          icon: 'fas fa-edit text-green',
          visible: this.showEditAction,
          click: () => {
            this.$router.push({
              name: 'inventoryMaintenanceEquipmentEdit',
              params: {
                id: this.$route.params.id,
                equipmentId: this.item.id,
              },
            });
          },
        },
        {
          name: 'Historial de Equipo',
          icon: 'fas fa-clock-rotate-left text-green',
          visible: this.isDetailTab,
          click: () => {
            this.$router.push({
              name: 'inventoryMaintenanceEquipmentDetails',
              params: {
                id: this.$route.params.id,
                equipmentId: this.item.id,
              },
              query: { tab: InventoryManagementDetailTabs.History },
            });
          },
        },
        {
          name: 'Historial de Custodio',
          icon: 'fas fa-user-clock text-green',
          visible: this.isDetailTab,
          click: () => {
            this.$router.push({
              name: 'inventoryMaintenanceEquipmentDetails',
              params: {
                id: this.$route.params.id,
                equipmentId: this.item.id,
              },
              query: { tab: InventoryManagementDetailTabs.Custodian },
            });
          },
        },
        {
          name: 'Marcar Disponible',
          icon: 'fas fa-file-check text-green',
          visible: this.canMarkAvailable,
          click: () => this.handlerMarkAvailable(),
        },
        {
          name: 'Facilitar',
          icon: 'fas fa-arrow-to-right text-green',
          visible: this.canLoan,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.LOANEQUIPMENT;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Historial de Bitácora',
          icon: 'fas fa-clock text-green',
          visible: this.canViewStatusSummary,
          click: () => {
            this.$router.push({
              name: 'inventoryMaintenanceEquipmentDetails',
              params: {
                id: this.$route.params.id,
                equipmentId: this.item.id,
              },
              query: { tab: InventoryManagementDetailTabs.Binnacle },
            });
          },
        },
        {
          name: 'Notificar Devolución',
          icon: 'fas fa-arrow-to-left  text-green',
          visible:
            this.canViewStatusSummary &&
            (this.isEquipmentLoan || this.isEquipmentPendingReturn),
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.NOTIFYRETURN;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Notificar Extensión',
          icon: 'fas fa-clock  text-green',
          visible: this.showLoanExtensionAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.LOANEXTENSION;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Inactivar',
          icon: 'fas fa-ban text-muted',
          visible: this.showInactiveAction,
          click: this.inactive,
        },
        {
          name: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          visible: this.showEliminateAction,
          click: this.eliminate,
        },
        {
          name: 'Asignar',
          icon: 'fas fa-plus-circle text-green',
          visible:
            this.inventoryFlow &&
            !this.fromAcquisition &&
            !this.outOfMyInventory &&
            this.recommendation?.equipmentId == null,
          click: async () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.ASSIGNEQUIPMENT;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Desasignar',
          icon: 'fas fa-minus-circle text-green',
          visible:
            !this.outOfMyInventory &&
            Boolean(this.recommendation?.equipmentId) &&
            this.isAssigned,
          click: this.unassign,
        },
        {
          name: 'Solicitar Transferencia',
          icon: 'fas fa-arrow-right-arrow-left text-green',
          visible:
            this.outOfMyInventory &&
            !this.isPendingTransfer &&
            this.recommendation.equipmentId == null,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.TRANSFER;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Información de solicitud',
          icon: 'fas fa-info-circle text-green',
          visible: this.showTransferInfoAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.TRANSFERINFO;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Cancelar Transferencia',
          icon: 'fas fa-times-circle text-red',
          visible: this.showCancelTransferAction,
          click: () => {
            this.selectedTemplateTabIndex =
              TEMPLATE_TAB_INDEX.TRANSFERCANCELLATION;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Confirmar Transferencia',
          icon: 'fas fa-check-circle text-green',
          visible: this.showConfirmTransferAction,
          click: () => {
            this.selectedTemplateTabIndex =
              TEMPLATE_TAB_INDEX.TRANSFERCONFIRMATION;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Decomisar',
          icon: 'fas fa-ban text-danger',
          visible: this.showSeizeAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.SEIZE;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Asignar CAAT',
          icon: 'fas fa-user-plus text-green',
          visible: this.showCaatAssigmentAction,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.ASSIGNCAAT;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
        {
          name: 'Añadir Bitácora',
          icon: 'far fa-comment text-green',
          visible: this.canViewStatusSummary,
          click: () => {
            this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.BINNACLE;
            this.isOpen = true;
            this.$emit('open', this.item);
          },
        },
      ];
    },
    showBinnacle() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.BINNACLE;
    },
    showAssignEquipment() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.ASSIGNEQUIPMENT
      );
    },
    showEquipment() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
    },
    showTransfer() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFER;
    },
    showTransferCancellation() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFERCANCELLATION
      );
    },
    showTransferConfirmation() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFERCONFIRMATION
      );
    },
    showLoanExtensionForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.LOANEXTENSION;
    },
    showTransferInfoAction() {
      return (
        ((this.fromAcquisition || this.outOfMyInventory) &&
          this.item.statusId == peiAtServiceEquipmentStatus.PendingTransfer) ||
        this.item.statusId == peiAtServiceEquipmentStatus.Reserved
      );
    },
    showCaatAssigmentAction() {
      return (
        (this.item.statusId == peiAtServiceEquipmentStatus.Available ||
          this.item.statusId == peiAtServiceEquipmentStatus.Processed) &&
        this.isDetailTab &&
        this.userHasPermissions(
          'technologyassistance.inventory.assigncaattoequipment'
        )
      );
    },
    showSeizeAction() {
      return (
        this.isReturned &&
        this.isDetailTab &&
        this.userHasPermissions(
          'technologyassistance.inventory.toseizeequipment'
        )
      );
    },
    showLoanExtensionAction() {
      return (
        [peiAtServiceEquipmentStatus.Loan].includes(this.item.statusId) &&
        this.isDetailTab &&
        this.item.loanId
      );
    },
    showAdditionalInfo() {
      return this.showEquipment && this.inventoryFlow;
    },
    showTransferRequestInfo() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TRANSFERINFO;
    },
    showCaatAssignment() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.ASSIGNCAAT;
    },
    isPanelOpen() {
      return this.fromAcquisition ? this.isOpen : this.item.isOpen;
    },
    loanTitle() {
      return this.isEquipmentAssigned || this.isEquipmentLoan
        ? 'Seleccione Accesorios para Donar'
        : 'Seleccione Accesorios para el Equipo';
    },
    isAssigned() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.Assigned &&
        this.editable
      );
    },
    isEquipmentAssigned() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Assigned;
    },
    isEquipmentPendingReturn() {
      return this.item.statusId === peiAtServiceEquipmentStatus.PendingReturn;
    },
    isEquipmentLoan() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Loan;
    },
    isPendingTransfer() {
      return this.item.statusId == peiAtServiceEquipmentStatus.PendingTransfer;
    },
    showCancelTransferAction() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.PendingTransfer &&
        this.editable
      );
    },
    showConfirmTransferAction() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.Reserved &&
        this.item.transfer?.statusId == transferStatuses.OnTransferRoute &&
        this.editable
      );
    },
    canMarkAvailable() {
      return [
        peiAtServiceEquipmentStatus.Processed,
        peiAtServiceEquipmentStatus.Inactive,
        peiAtServiceEquipmentStatus.Returned,
      ].includes(this.item.statusId);
    },
    showInactiveAction() {
      return (
        this.userHasPermissions(
          'technologyassistance.inventory.inactiveequipment'
        ) &&
        this.canViewStatusSummary &&
        [
          peiAtServiceEquipmentStatus.Available,
          peiAtServiceEquipmentStatus.Processed,
        ].includes(this.item.statusId)
      );
    },
    showEditAction() {
      return (
        this.userHasPermissions(
          'technologyassistance.inventory.editequipment'
        ) &&
        this.canViewStatusSummary &&
        this.item.statusId == peiAtServiceEquipmentStatus.Processed
      );
    },
    showEliminateAction() {
      return (
        this.userHasPermissions(
          'technologyassistance.inventory.deleteequipment'
        ) &&
        this.canViewStatusSummary &&
        ![
          peiAtServiceEquipmentStatus.Assigned,
          peiAtServiceEquipmentStatus.Reserved,
          peiAtServiceEquipmentStatus.PendingTransfer,
          peiAtServiceEquipmentStatus.Loan,
        ].includes(this.item.statusId)
      );
    },
    isProcessed() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Processed;
    },
    isInactivated() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Inactive;
    },
    isReturned() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Returned;
    },
    isAvailable() {
      return this.item.statusId === peiAtServiceEquipmentStatus.Available;
    },
    isDetailTab() {
      return this.canViewStatusSummary && !this.fromAcquisition;
    },
    canLoan() {
      return (
        [
          peiAtServiceEquipmentStatus.Available,
          peiAtServiceEquipmentStatus.Assigned,
          peiAtServiceEquipmentStatus.Loan,
        ].includes(this.item.statusId) &&
        this.isDetailTab &&
        this.userHasPermissions(
          'technologyassistance.inventory.assistantequipment'
        )
      );
    },
    showLoanForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.LOANEQUIPMENT;
    },
    isAlertvisible() {
      return (
        this.item.statusId == peiAtServiceEquipmentStatus.Loan &&
        this.item.returnDate &&
        this.isEquipmentDueDate &&
        this.item.isAlertActivated
      );
    },
    setAlertType() {
      return this.missingDaysToReturnEquipment < 0
        ? 'alert-danger text-danger'
        : 'alert-warning custom-text-warning';
    },
    missingDaysToReturnEquipment() {
      if (!this.item.returnDate) return null;

      const returnEquipmentDate = moment(this.item.returnDate);
      const currentDate = moment(new Date());
      returnEquipmentDate.set({ minute: 0, hour: 0, second: 0 });
      return returnEquipmentDate.diff(currentDate, 'days');
    },
    isEquipmentDueDate() {
      if (isNaN(this.missingDaysToReturnEquipment)) return false;
      return this.missingDaysToReturnEquipment <= 4;
    },
    alertMessage() {
      const returnEquipmentDate = date(this.item.returnDate);
      return this.missingDaysToReturnEquipment < 0
        ? `Fecha de devolución de equipo se encuentra vencida (${returnEquipmentDate}).`
        : `Fecha de devolución de equipo está próxima a vencer (${returnEquipmentDate}).`;
    },
    showSeizeForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.SEIZE;
    },
    showNotifyReturnForm() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.NOTIFYRETURN;
    },
    isCaatMissing() {
      return this.item.checked && !this.item.caatId;
    },
  },
  methods: {
    async onToggle() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;

      if (this.item.isOpen) {
        this.isOpen = false;
        this.toResetBinnacleFields();
        this.$emit('close', this.item);
        return;
      }

      this.isOpen = true;
      this.$emit('open', this.item);
    },
    onCloseCallout() {
      this.$emit('close', this.item);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.EQUIPMENTINFO;
      this.$emit('refresh', this.item);
    },
    async unassign() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea desasignar el equipo?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.unassignEquipment(this.item.id);
        this.ShowToast(
          'Éxito',
          'El equipo ha sido desasignado exitosamente.',
          'success'
        );
        this.recommendation.equipmentId = null;
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    async inactive() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el estatus del equipo de Disponible a Inactivo?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.inactiveEquipment(this.item.id);
        this.ShowToast(
          'Éxito',
          'El equipo ha sido inactivado exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    async eliminate() {
      try {
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea eliminar el equipo?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.eliminateEquipment(this.item.id);
        this.ShowToast(
          'Éxito',
          'El equipo ha sido eliminado exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    async onCancelAction() {
      this.$emit('refresh');
      await this.onToggle();
    },
    async handlerMarkAvailable() {
      try {
        if (!this.item.caatId) {
          this.ShowToast(
            'El equipo debe tener asignado un CAAT para poder marcarlo disponible'
          );
          return;
        }
        const confirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el estatus del equipo de ${this.item.statusName} a Disponible?`
        );
        if (!confirmed) return;
        await inventoryCatalogService.markAvailable(this.item.id);
        this.ShowToast(
          'Éxito',
          'El equipo ha sido marcado como disponible exitosamente.',
          'success'
        );
        this.$emit('refresh', this.item);
      } catch (error) {
        this.ShowToast('Error', error.response?.data?.message, 'error');
      }
    },
    check(item) {
      this.$emit('check', item);
    },
    async handlerLoanEquipment(model) {
      const {
        equipmentId,
        caatId,
        reasonId,
        comment,
        studentSieId,
        returnDate,
        typeFacilityId,
        phone,
        expedient,
      } = model;
      const payload = {
        equipmentId,
        unselectedAccessories: this.unSelectedItems,
        caatId,
        reasonId,
        comment,
        studentSie: studentSieId,
        returnDate,
        type: typeFacilityId,
        phone,
        expedient,
      };

      try {
        await inventoryCatalogService.loanEquipment(payload);
        const loanAction =
          typeFacilityId === TypeFacility.DONACION ? 'donado' : 'prestado';
        this.ShowToast(
          'Éxito',
          `El equipo ha sido ${loanAction} exitosamente.`,
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error.response?.data.message, 'error');
      }
    },
    async saveBinnacle() {
      this.binnacleModel.equipmentStatusId = this.item.statusId;
      const isValid = await this.$refs.binnacleForm.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      try {
        const payload = objectToFormData(this.binnacleModel);

        await inventoryCatalogService.addEquipmentBinnacle(
          this.item.id,
          payload
        );

        this.ShowToast(
          'Éxito',
          'Se ha guardado la bitácora correctamente',
          'success'
        );
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      } finally {
        this.onToggle();
      }
    },
    toResetBinnacleFields() {
      this.binnacleModel = {
        subject: null,
        file: null,
        comment: null,
        equipmentStatusId: null,
      };
    },
    async handlerConfiscate(model) {
      try {
        await inventoryCatalogService.consfiscateEquipment(model);
        this.ShowToast(
          'Éxito',
          'El equipo ha sido decomizado exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async handlerNotifyExtensionReturnDate(model) {
      try {
        await inventoryCatalogService.nofityLoanExtensionDate(model);
        this.ShowToast(
          'Éxito',
          'Se ha extendido la fecha de devolución exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    async handlerNotifyReturnDate(model) {
      try {
        await inventoryCatalogService.notifyReturnDate(model);
        this.ShowToast(
          'Éxito',
          'Se ha notificado la devolución exitosamente.',
          'success'
        );
        this.onCloseCallout();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.gap-y-2 {
  gap: 20px 0px;
}

.bg-white {
  ::v-deep div.bg-secondary-3 {
    background-color: white !important;
  }
}

::v-deep .dot {
  padding: 18px !important;
  margin-bottom: 1px;
}

::v-deep .title-icon {
  padding-bottom: 3px;
}
.border-left-2 {
  border-left: 2px solid #dee2e6 !important;
}
.border-bottom-2 {
  border-bottom: 2px solid #dee2e6 !important;
}
.custom-text-warning {
  color: #af6708 !important;
}
</style>
